import React, { useCallback, useState, useEffect } from "react";
import { Grid, Container } from "@mui/material";
import { connect } from "react-redux";
import jpActions from "../../../../actions/jpActions";
import { getJobPlans, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import Fetching from "../../../Common/Fetching";
import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";
import JobPlanListItem from "./JobPlanListItem";
import DayJS from "react-dayjs/source";
import BreadcrumbBuilder from "../BreadcrumbBuilder";

const appCode = "P-JP";

function JobPlanList({
    jobPlans = [],
    isFetching,
    getJobPlans,
    deleteJobPlan,
}) {
    const [openDialog, setOpenDialog] = useState(null);
    const [selectedJobPlan, setSelectedJobPlan] = useState(null);

    useEffect(() => {
        getJobPlans(appCode);
    }, [getJobPlans]);

    const onDelete = useCallback(
        (id) => {
            deleteJobPlan(appCode, id);
        },
        [deleteJobPlan]
    );

    const handleCloseDialog = useCallback(() => {
        setOpenDialog(null);
        setSelectedJobPlan(null);
    }, []);

    const openDeleteDialog = useCallback((jobPlan) => {
        setSelectedJobPlan(jobPlan);
        setOpenDialog("delete");
    }, []);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isFetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {jobPlans.map((jobPlan, index) => (
                    <Grid item xs={12} key={index}>
                        <JobPlanListItem
                            jobPlan={jobPlan}
                            onDelete={() => openDeleteDialog(jobPlan)}
                        />
                    </Grid>
                ))}

                {openDialog === "delete" && !!selectedJobPlan && (
                    <ConfirmDialog
                        open={true}
                        title="Delete jobplan"
                        content={
                            <>
                                The following job plan will be deleted:{" "}
                                <DayJS format="DD MMM YYYY">
                                    {selectedJobPlan.effectiveDate}
                                </DayJS>
                            </>
                        }
                        confirmButtonLabel="Delete"
                        onConfirm={() => onDelete(selectedJobPlan.id)}
                        onCancel={handleCloseDialog}
                        onClose={handleCloseDialog}
                    />
                )}
            </Grid>
        </Container>
    );
}

const mapStateToProps = (state) => ({
    jobPlans: getJobPlans(state),
    isFetching: isFetching(state, DataTypes.JP_JOBPLAN),
});

export default connect(mapStateToProps, {
    getJobPlans: jpActions.getJobPlans,
    deleteJobPlan: jpActions.deleteJobPlan,
})(JobPlanList);
